// i18n area 'tasks' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.et-EE.meta.json.
import type { enUS } from './tasks'

export const etEE: typeof enUS = {
  macrotasks: {
    title: 'Makrotaskid',
    subtitle: 'Liitoperatsioonid — jätkatavad nurjunud sammust või katkestatavad',
    colType: 'Tüüp',
    colTarget: 'Objekt',
    colPhase: 'Faas',
    colSteps: 'Sammud',
    empty: 'Makrotaskid puuduvad',
    detail: 'Üksikasjad',
    failedAt: 'nurjus sammul',
    resume: 'Proovi uuesti nurjunud sammust',
    abort: 'Katkesta kõik',
    cancel: 'Tühista',
    actionError: 'Toiming lükati tagasi'
  },
  tasks: {
    title: 'Taskid',
    searchPlaceholder: 'Otsi tüübi või sihtobjekti järgi',
    type: 'Tüüp',
    target: 'Sihtobjekt',
    phaseLabel: 'Faas',
    progress: 'Edenemine',
    started: 'Alustatud',
    finished: 'Lõpetatud',
    node: 'Sõlm',
    empty: 'Taskid puuduvad',
    loadError: 'Taskide laadimine ebaõnnestus — kas TVirti backend on kättesaadav?',
    limboHint: "Sõlm '{node}' pole kättesaadav alates {time} — task hoiab oma sihtobjekti write lease'i, kuni sõlm naaseb või atesteeritakse seiskunuks",
    nodeAttested: 'Sõlm atesteeritud seiskunuks',
    phase: {
      queued: 'Järjekorras',
      running: 'Töötab',
      succeeded: 'Valmis',
      failed: 'Nurjunud',
      cancelled: 'Tühistatud',
      'failed-at-step': 'Nurjus sammul',
      aborted: 'Katkestatud'
    },
    dropdown: {
      tooltip: 'Käimasolevad taskid',
      title: 'Käimasolevad taskid',
      empty: 'Käimasolevad taskid puuduvad',
      viewAll: 'Kuva kõik taskid'
    },
    detail: {
      open: 'Üksikasjad',
      scope: 'Scope',
      message: 'Sõnum',
      params: 'Parameetrid',
      result: 'Tulemus',
      errorTitle: 'Viga',
      steps: 'Sammud',
      failedAt: 'nurjus sammul',
      superseded: 'asendatud',

      // Dialoogi standard (voor #156): alamtaski koht ülemtaski plaanis,
      // ülemtask ise (avatav kohapeal) ja süüdlaseks olev samm.
      step: 'Samm',
      parent: 'Ülemtask',
      failedStep: 'Nurjunud samm',
      log: 'Logi',
      logEmpty: 'Logiridu veel pole',
      close: 'Sulge'
    },
    actions: {
      cancel: 'Tühista',
      resume: 'Proovi uuesti nurjunud sammust',
      abort: 'Katkesta kõik (võtab tehtud sammud tagasi)',
      refused: 'Toiming lükati tagasi'
    }
  },
  events: {
    loadError: 'Päevikut ei õnnestunud laadida — kas TVirti taustsüsteem on kättesaadav?',
    title: 'Sündmused',
    subtitle: 'Klastri ajalooline mälu: toimunud faktid, uusimad ees',
    filterSeverity: 'Raskusaste',
    filterCategory: 'Kategooria',
    filterAll: 'Kõik',
    searchLabel: 'Otsi',
    searchPlaceholder: 'Otsi kogu päevikust',
    subjectFilter: '{subject} sündmused — näita kõiki',
    colAt: 'Millal',
    colSeverity: 'Raskusaste',
    colType: 'Tüüp',
    colSubject: 'Objekt',
    colActor: 'Kes',
    colNode: 'Node',
    colMessage: 'Teade',
    empty: 'Sündmusi pole',
    loadMore: 'Laadi veel',
    actorSystem: 'süsteem',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Sündmuse ID',
    taskCollectedHint: 'Taskil on lühem säilitusaeg: kogutud taski link enam ei vasta',
    severity: {
      info: 'Info',
      warning: 'Hoiatus',
      error: 'Viga',
      critical: 'Kriitiline'
    },
    category: {
      lifecycle: 'Elutsükkel',
      config: 'Seadistus',
      availability: 'Käideldavus',
      security: 'Turvalisus'
    },
    type: {
      haNetsvcFailedOver: 'Võrguteenuse failover',
      haNetsvcNoCandidate: 'Võrguteenus ilma kandidaatsõlmeta',
      haNetsvcReaped: 'Lokaalne instants koristati sõlme naasmisel',
      netsvcFloatipMoved: 'Ujuv IP liikus teisele hoidjale',
      netsvcFloatipNoHolder: 'Ujuv IP ilma terve sihtmärgita',
      haAppFailedOver: 'App-eksemplari failover',
      haAppNoCandidate: 'App-eksemplar ilma kandidaatsõlmeta',
      haAppStorageLocalSkip: 'App-eksemplari ei viidud üle: püsiandmed on surnud sõlme kohalikud',
      haAppReaped: 'App-eksemplari kohalik pod koristati taasliitumisel'
    }
  },
  audit: {
    loadError: 'Auditiregistrit ei õnnestunud laadida — kas TVirti taustsüsteem on kättesaadav?',
    title: 'Audit',
    subtitle: 'Kes mida tegi, millal ja millise objektiga — katsetatud toimingud, keeldumised kaasa arvatud',
    filterOutcome: 'Tulem',
    filterAll: 'Kõik',
    filterSudo: 'Ainult kõrgendatud toimingud',
    colAt: 'Millal',
    colActor: 'Kes',
    colAction: 'Toiming',
    colTarget: 'Objekt',
    colOutcome: 'Tulem',
    colNode: 'Node',
    empty: 'Toiminguid pole salvestatud',
    loadMore: 'Laadi veel',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Marsruut',
    detailProblem: 'Põhjus',
    detailTask: 'Task',
    detailClientIp: 'Kust',
    detailId: 'Kirje ID',
    detailSession: 'Seanss',
    taskHint: 'Vastuvõetud toimingu tulem elab sündmuste päevikus, sama task-i id all',
    outcome: {
      succeeded: 'Õnnestus',
      accepted: 'Vastu võetud',
      denied: 'Keelatud',
      rejected: 'Tagasi lükatud',
      failed: 'Nurjus'
    }
  },
  notifications: {
    loadError: 'Teavitusi ei õnnestunud laadida — kas TVirti taustsüsteem on kättesaadav?',
    actionError: 'Toiming lükati tagasi',
    title: 'Teavitused',
    subtitle: 'Sihtkohad, kuhu päeviku faktid klastrist väljuvad',
    rulesTitle: 'Reeglid',
    rulesSubtitle: 'Millised faktid väljuvad ja kuhu',
    deliveriesTitle: 'Kohaletoimetamised',
    deliveriesSubtitle: 'Iga teavituse tulemus koos põhjusega, kui see ebaõnnestub',
    colName: 'Nimi',
    colKind: 'Tüüp',
    colWhere: 'Kuhu',
    colScope: 'Scope',
    colSeverity: 'Raskusaste',
    colMatch: 'Filter',
    colTargets: 'Sihtkoht',
    colAt: 'Millal',
    colState: 'Olek',
    colEvent: 'Sündmus',
    colAttempts: 'Katsed',
    colOutcome: 'Tulemus',
    empty: 'Ridu pole',
    matchAll: 'kõik faktid',
    test: 'Testi',
    testOk: 'Testteavitus toimetati kohale {target}',
    testFailed: 'Test sihtkohta {target} ebaõnnestus: {reason}',
    retry: 'Pane uuesti järjekorda',
    retried: 'Kohaletoimetamine pandi uuesti järjekorda',
    grouped: 'ja veel {count} kordust',
    state: {
      failed: 'Ebaõnnestus',
      pending: 'Järjekorras',
      sending: 'Saatmisel',
      sent: 'Saadetud'
    },
    tabTargets: 'Sihtkohad',
    tabRules: 'Reeglid',
    tabDeliveries: 'Kohaletoimetamised',
    targetCreateTitle: 'Uus sihtkoht',
    ruleCreateTitle: 'Uus reegel',
    nameHint: 'Väiketähed, numbrid ja sidekriipsud; unikaalne skoobi kohta',
    kindImmutableHint: 'Muutumatu: tüübi muutmine tähendab uue sihtkoha loomist',
    kindSmtp: 'Post (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Olek',
    enabledOn: 'Aktiivne',
    enabledOff: 'Peatatud',
    smtpHost: 'SMTP-server',
    smtpPort: 'Port',
    smtpPortHint: 'Tavaliselt: 25 ilma TLS-ita, 587 starttls-iga, 465 tls-iga',
    smtpSecurity: 'Turvalisus',
    smtpFrom: 'Saatja',
    smtpTo: 'Saajad',
    smtpToHint: 'Üks või mitu komadega eraldatud aadressi',
    webhookUrl: 'URL',
    payload: 'Sisu',
    payloadHint: 'Minimal puhul sündmuse sõnum ja andmed klastrist ei välju',
    credential: 'Mandaat',
    credentialNone: 'Puudub',
    credentialHintSmtp: 'Relee konto võtmehoidlast; puudub tähendab anonüümset SMTP-d',
    credentialHintWebhook: 'Allkirjastamise saladus võtmehoidlast; allkirjata saab igaüks, kes URL-i teab, esineda klastrina',
    minSeverityHint: 'Lävi, mitte hulk: sellest raskusastmest ülespoole',
    categories: 'Kategooriad',
    categoriesHint: 'Tühi = kõik',
    types: 'Sündmuse tüübid',
    typesHint: 'Komadega eraldatud; tühi = kõik. Tundmatu tüüp lükatakse tagasi',
    targetsHint: 'Vähemalt üks; need peavad asuma reegli skoobis või selle esivanemas',
    recursiveOn: 'Ka alamskoobid',
    recursiveOff: 'Ainult see skoop',
    recursiveHint: 'Ressursid elavad lehtedes: ilma lastega teatab juures olev reegel peaaegu mitte midagi',
    repeatWindow: 'Rühmitamisaken (s)',
    repeatWindowHint: 'Akna sees kordused posti ei saada: neid loetakse esimese juures. 0 lülitab välja',
    targetInUseError: 'Sihtkohta {name} kasutab veel üks reegel'
  }
}
